import { DefaultOptionType } from 'antd/es/select';
import React, { FC, memo, useCallback } from 'react';
import { useAppTranslation } from 'app/config/i18Config/hooks';
import { Select } from 'shared/ui/Select';
import { SizeCodesListFilterKeys } from '../../model/types';
import { SizeGroup } from 'entities/SizeCode';

interface SizeGroupSelectProps {
  value: string;
  onChange: (value: string, label: string) => void;
  onClear: (filterKey: string) => void;
}

export const SizeGroupSelect: FC<SizeGroupSelectProps> = memo((props) => {
  const { value, onChange, onClear } = props;

  const { t } = useAppTranslation('boxes');

  const sizeCodeGroupOptions = Object.values(SizeGroup).map((group) => ({
    label: group,
    value: group,
  }));

  const handleChange = useCallback(
    (value: string, option?: DefaultOptionType | DefaultOptionType[]): void => {
      if (!Array.isArray(option) && typeof option?.label === 'string') {
        onChange(value, option.label);
      }
    },
    [onChange],
  );

  const clearFilter = useCallback(() => {
    onClear(SizeCodesListFilterKeys.sizeGroup);
  }, [onClear]);

  return (
    <Select
      containerClassName="flex-1"
      className="w-full"
      label={t('Size Group')}
      placeholder={t('All')}
      bordered
      allowClear
      options={sizeCodeGroupOptions}
      value={value}
      onChange={handleChange}
      onClear={clearFilter}
    />
  );
});
